import ruleExecutor from '@shopee/banking-utils/src/rule';
import { compare } from '@shopee/banking-utils/src/version';
import { getAppVersionString } from '@/utils/misc';

// 维护功能名称
const FunctionName = {
  BRIDGE_TRACKING_RECORD: 'BRIDGE_TRACKING_RECORD',
};

// 功能所需条件
const Condition = {
  [FunctionName.BRIDGE_TRACKING_RECORD]: 'country!=id||app_version>=2.5',
};

export const allowBridgeTrackingRecord = () => {
  const app_version = getAppVersionString();
  const country = process.env.SHOPEE_COUNTRY;
  return ruleExecutor(
    Condition[FunctionName.BRIDGE_TRACKING_RECORD],
    {
      country,
      app_version,
    },
    {
      app_version: compare,
    },
  );
};
